
import { supabase } from "@/integrations/supabase/client";

export const fetchUsers = async () => {
  try {
    console.log('Fetching profiles with verification status...');
    
    // Get profiles data with all needed fields in a single query
    const { data: profiles, error: profilesError } = await supabase
      .from('profiles')
      .select('id, display_name, email, tos_accepted, is_verified, address, location')
      .order('display_name', { ascending: true });
    
    if (profilesError) {
      console.error('Error fetching profiles:', profilesError);
      throw profilesError;
    }
    
    // Calculate profile completeness here - now only requires address
    // Phone requirement will be checked via notification_preferences join when needed
    const profilesWithCompleteness = profiles?.map(profile => ({
      ...profile,
      is_profile_complete: !!(profile.address)
    })) || [];
    
    console.log('Profiles fetched with completeness data:', profilesWithCompleteness.length);
    
    return profilesWithCompleteness;
  } catch (error) {
    console.error('Error in fetchUsers:', error);
    throw error;
  }
};
